import * as XLSX from 'xlsx';
import { displayIso } from '@archre2/react-core';

export const formatDate = (val) => {
  return displayIso(val, 'dateNoTimezoneCorrection');
};

export const parseExcel = (file, sheet = 0, handleData) => {
  const reader = new FileReader();
  reader.onload = (evt) => {
    const bstr = evt.target.result;
    const wb = XLSX.read(bstr, {
      type: 'buffer',
    });
    const sheets = wb.SheetNames;
    const ws = wb.Sheets[wb.SheetNames[sheet]];
    const excelData = XLSX.utils.sheet_to_json(ws, {
      header: 1,
      range: 0,
      blankrows: true,
      raw: false,
      dateNF: 'mm/dd/yyyy',
      defval: '',
    });

    handleData({ excelData, sheets });
  };
  reader.readAsArrayBuffer(file);
};

const getLocaleFromBrowser = () => {
  let locale = navigator?.language || window?.navigator?.language || 'en-US';

  return locale;
};
export const getCurrencyDetails = (currency) => {
  let symbol = '$';
  let digitGroupSeparator = ',';
  let decimalCharacter = '.';
  const locale = getLocaleFromBrowser();
  if (currency === 'none') {
    symbol = '';
    digitGroupSeparator = ',';
    decimalCharacter = '.';
  } else if (currency) {
    try {
      let formattedValue = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
      }).format(1000);
      // symbol = formattedValue.replace(/,/g, '.');
      // symbol = symbol.replace(/,/g, '.');
      // symbol = symbol.replace(/[0-9]/g, '');
      symbol = formattedValue.replace(/[0-9,.]/g, '');
      let extractedValue = formattedValue.match(/[\d,.]+/g)[0];
      digitGroupSeparator = extractedValue.charAt(1);
      decimalCharacter = extractedValue.charAt(5)
        ? extractedValue.charAt(5)
        : digitGroupSeparator === ','
        ? '.'
        : ',';
    } catch (error) {
      symbol = '';
      digitGroupSeparator = ',';
      decimalCharacter = '.';
      console.log(error);
    }
  }

  return { symbol, digitGroupSeparator, decimalCharacter };
};

export const dateCompareWithoutOffset = (date1, date2) => {
  return (
    displayIso(date1, 'dateNoTimezoneCorrection') ===
    displayIso(date2, 'dateNoTimezoneCorrection')
  );
};

export const formatCurrency = (value, currency = 'USD', label = '') => {
  if (value === null || value === undefined) return 'N/A';

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return label
    ? `${label} ${formatter.format(value)}`
    : formatter.format(value);
};

export { mergeClassNames, styleObjectToClassNames } from './styleClassNames';
